import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BadgeNumComponent } from './badge-num.component';

@NgModule({
    declarations: [BadgeNumComponent],
    exports: [BadgeNumComponent],
    imports: [
        CommonModule,
    ],
})
export class BadgeNumModule { }
